<h2 mat-dialog-title>Project toevoegen</h2>

<mat-dialog-content>
    <p>Welk project wil je volgen?</p>

    @if (customerProjects === undefined) {
        <div class="loading">
            <mat-spinner diameter="32"></mat-spinner>
        </div>
    } @else if (customerProjects.length === 0) {
        <p class="empty-message">Je volgt alle beschikbare projecten al.</p>
    } @else {
        <mat-radio-group [(ngModel)]="customerProject" class="projects">
            @for (project of customerProjects; track project.id) {
                <mat-radio-button [value]="project" class="project">
                    <span class="project-name">{{ project.name }}</span>
                    <small>{{ project.customer_name }}</small>
                </mat-radio-button>
            }
        </mat-radio-group>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuleren</button>
    <button (click)="addCustomerProject()" [disabled]="!customerProject" color="primary" mat-raised-button>
        Toevoegen
    </button>
</mat-dialog-actions>
